<template>
  <div class="fccConfiguracoes">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <form autocomplete="off" @submit.prevent="editConfiguracoes" @change="editConfiguracoes">
        <div class="row innerPage space">
          <div class="col-sm-12">
            <fcc-select
              class="mb-4"
              placeholder="Selecione a complexidade da senha do usuário"
              labelField="mensagem"
              @change="editConfiguracoes()"
              valueField="id"
              :clearable="false"
              v-model="listagemParametrosApp.appparamcomplexidadesenha"
              :options="complexidadeSenha"
            >
              Complexidade de senha (Nível)
            </fcc-select>
          </div>

          <div class="col-sm-4">
            <fccInput
              type="number"
              extraClasses="inputLabel"
              required
              v-model="listagemParametrosApp.appparamvalidadetoken"
            >
              Validade Token (Horas)
            </fccInput>
          </div>

          <div class="col-sm-4">
            <fccInput
              type="number"
              extraClasses="inputLabel"
              required
              v-model="listagemParametrosApp.appparamtemponovotoken"
            >
              Tempo para Renovação Token (Horas)
            </fccInput>
          </div>
          <div class="col-sm-4">
            <fccInput
              type="number"
              extraClasses="inputLabel"
              required
              v-model="listagemParametrosApp.appparamtemponotificacoes"
            >
              Tempo para Notificações (Minutos)
            </fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-4">
            <fccInput
              type="number"
              extraClasses="inputLabel"
              required
              v-model="listagemParametrosApp.appparamtentativasloginbloqueio"
            >
              Tentativas para Bloqueio de Login
            </fccInput>
          </div>
          <div class="col-sm-4">
            <fccInput
              type="number"
              extraClasses="inputLabel"
              required
              v-model="listagemParametrosApp.appparamtempoesperabloqueio"
            >
              Tempo de espera para Desbloqueio (Minutos)
            </fccInput>
          </div>
        </div>
        <div class="row innerPage space">
          <div class="col-sm-4">
            <span
              ><toggle-button
                @change="editConfiguracoes"
                v-model="listagemParametrosApp.appparampermitevariassecoes"
                :sync="true"
              />
              Permite várias Sessões</span
            >
          </div>
          <div class="col-sm-4">
            <span
              ><toggle-button
                @change="editConfiguracoes"
                v-model="listagemParametrosApp.appparamvalidafluxo"
                :sync="true"
              />
              Valida fluxo</span
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import './assets/sass/fccConfiguracoes.scss'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Configurações do Sistema',
      listagemParametrosApp: [],
      complexidadeSenha: [
        { id: 1, mensagem: 'Senha com no mínimo 5 caracteres' },
        { id: 2, mensagem: 'Senha com no mínimo 5 caracteres combinados em letras e números' },
        {
          id: 3,
          mensagem:
            'Senha com no mínimo 5 caracteres combinados em letras, números e caracteres especiais'
        },
        {
          id: 4,
          mensagem:
            'Senha com no mínimo 9 caracteres combinados em letras, números e caracteres especiais'
        }
      ]
    }
  },
  methods: {
    editConfiguracoes: function () {
      axios
        .put(
          this.$fccStore.state.baseUrlSeguranca + 'App/alterarappparam',
          this.listagemParametrosApp,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
    },
    listandoParametrosApp: function () {
      let appID = process.env.VUE_APP_API_ID

      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(
          this.$fccStore.state.baseUrlSeguranca + 'App/listarappparam/' + appID,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemParametrosApp = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  mounted: function () {
    this.listandoParametrosApp()
  }
}
</script>

